module.exports = __webpack_public_path__ + "img/student-grand-prize.b79530b.png";